var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15.9564 5.45688C16.3468 5.06623 16.3466 4.43306 15.9559 4.04267C15.5653 3.65227 14.9321 3.65247 14.5417 4.04312L10.0001 8.58767L5.45847 4.04312C5.06807 3.65247 4.4349 3.65227 4.04425 4.04267C3.6536 4.43306 3.6534 5.06623 4.0438 5.45688L8.58577 10.0018L4.04267 14.5478C3.65227 14.9385 3.65247 15.5716 4.04312 15.962C4.43377 16.3524 5.06694 16.3522 5.45733 15.9616L9.99896 11.417L14.5406 15.9616C14.931 16.3522 15.5642 16.3524 15.9548 15.962C16.3455 15.5716 16.3457 14.9385 15.9553 14.5478L11.4133 10.0029L15.9564 5.45688Z","fill":"#9E9E9E"}));
}

Cross.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Cross;

Cross.default = Cross;
